<template>
    <v-card>
        <v-card-title class="headline">
            {{ $i18n.t('editPassword' )}}

            <v-spacer/>

            <v-btn @click="$store.commit('setEditPasswordDialog', false)">
                {{ $t('cancel') }}
                <v-icon right>clear</v-icon>
            </v-btn>
            <v-btn @click="submit" class="ml-7" color="teal">
                {{ $t('save') }}
                <v-icon right>done</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text>
            <v-container grid-list-xl>
                <v-form ref="form" @submit="submit">
                     <v-text-field
                        v-model="newPassword"
                        :rules="passwordRules"
                        :type="newPasswordHidden ? 'password' : 'text'"
                        :append-outer-icon="newPasswordHidden ? 'visibility' : 'visibility_off'"
                        :label="$t('newPassword')"
                        @click:append-outer="() => (newPasswordHidden = !newPasswordHidden)"
                        class="my-0 body-1 font-weight-light"/>
                </v-form>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { i18n } from '@/main.js' 

export default {
    data(){
        return {
            newPasswordHidden: true,
            passwordRules: [
                v => !v || v.indexOf(' ') < 0 || this.$i18n.t('spaces'),
                v => !v || v.length >= 8 || this.$i18n.t('shortPassword'),
            ],
        }
    },

    methods: {
        submit() {
            if (this.$refs.form.validate())
                this.$store.dispatch('updateUser')
        },
    },

    computed: {
        ...mapGetters([
            'isLoading',
            'getTest',
            'getUserNewPassword',
        ]),
        newPassword: {
            get() { return this.getUserNewPassword },
            set(value) { this.$store.commit('setUserNewPassword', value) },
        },
    },
}
</script>
